import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import styles from './FilterModalPatternB.module.css';
import searchFilterPropType from '../../../../../../utility/PropTypes/searchFilterPropType';
import BaseFacet from '../../../../../../classes/facets/BaseFacet/BaseFacet';

function FilterModalPatternB({
  facetType,
  facetClass,
  facets,
  addFacet,
  removeFacet,
}) {
  const [anyOfFacetValue, setAnyOfFacetValue] = useState('');
  const [noneOfFacetValue, setNoneOfFacetValue] = useState('');
  const anyOfFacets = facets.filter((facet) => facet.operatorId === OperatorTypes.CONTAINS);
  const noneOfFacets = facets.filter((facet) => facet.operatorId === OperatorTypes.NOT_CONTAIN);

  const handleAddFacetValue = (operatorType) => {
    const newFacet = {
      facetId: facetType.id,
      operatorId: operatorType,
      value1: operatorType === OperatorTypes.CONTAINS
        ? anyOfFacetValue.toString()
        : noneOfFacetValue.toString(),
      value2: '',
    };
    addFacet(newFacet);
  };

  const handleRemoveFacetValue = (facetToRemoveId) => {
    const index = facets.findIndex(
      (f) => f.id === facetToRemoveId,
    );
    removeFacet(index);
  };

  /* istanbul ignore next */
  return (
    <div>
      <h6>
        {`${facetClass.getDisplayName()} ${facetClass.getDescription()}`}
      </h6>
      <div className="row mt-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <label htmlFor="anyOfSelect">
              <p className={`${anyOfFacets.length ? '' : 'text-muted'}`}>
                <b>ANY</b>
                {' '}
                of the following:
              </p>
            </label>
            <div className={styles.multiContainer}>
              {anyOfFacets.length
                ? anyOfFacets.map((facet, index) => (
                  <div
                    key={`${facet.id}-${index}`}
                    className={styles.multiValue}
                  >
                    <div>
                      <div className={styles.multiValueLabel}>
                        {facet.value1}
                      </div>
                    </div>
                    <div
                      tabIndex="0"
                      role="button"
                      data-testid="delete-anyof-facet"
                      className={styles.multiLabelRemove}
                      onClick={() => handleRemoveFacetValue(facet.id)}
                    >
                      <svg
                        height="14"
                        width="14"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                        focusable="false"
                        className={styles.svgIcon}
                      >
                        <path
                          d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
                        />
                      </svg>
                    </div>
                  </div>
                ))
                : (
                  <div className="text-muted" style={{ padding: '0.375em 0.75em' }}>
                    Add an entry
                    below
                  </div>
                )}
            </div>
            <div className="form-row align-items-center my-3">
              <div className="col-sm-10 ">
                <input
                  type="text"
                  data-testid="anyof-input"
                  className="form-control"
                  placeholder="Enter search term or phrase"
                  onChange={(e) => setAnyOfFacetValue(e.target.value)}
                  value={anyOfFacetValue}
                />
              </div>
              <div className="col-auto my-1">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-testid="anyof-input-submit"
                  onClick={() => handleAddFacetValue(OperatorTypes.CONTAINS)}
                  disabled={!anyOfFacetValue}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect2" style={{ marginBottom: 0 }}>
              <p className={`${noneOfFacets.length ? '' : 'text-muted'}`}>
                <b>NONE</b>
                {' '}
                of the following:
              </p>
            </label>
            <div className={styles.multiContainer}>
              {' '}
              {noneOfFacets.length
                ? noneOfFacets.map((facet, index) => (
                  <div key={`${facet.id}-${index}`} className={styles.multiValue}>
                    <div>
                      <div className={styles.multiValueLabel}>
                        {facet.value1}
                      </div>
                    </div>
                    <div
                      tabIndex="0"
                      role="button"
                      className={styles.multiLabelRemove}
                      onClick={() => handleRemoveFacetValue(facet.id)}
                    >
                      <svg
                        height="14"
                        width="14"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                        focusable="false"
                        className={styles.svgIcon}
                      >
                        <path
                          d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
                        />
                      </svg>
                    </div>
                  </div>
                ))
                : (
                  <div className="text-muted" style={{ padding: '0.375em 0.75em' }}>
                    Add an entry
                    below
                  </div>
                )}
            </div>
            <div className="form-row align-items-center my-3">
              <div className="col-sm-10 my-1">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter search term or phrase"
                  onChange={(e) => setNoneOfFacetValue(e.target.value)}
                  value={noneOfFacetValue}
                />
              </div>
              <div className="col-auto my-1">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleAddFacetValue(OperatorTypes.NOT_CONTAIN)}
                  disabled={!noneOfFacetValue}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
FilterModalPatternB.propTypes = {
  facetType: PropTypes.shape({
    id: PropTypes.number,
    validOperators: PropTypes.arrayOf(PropTypes.number),
    displayValue: PropTypes.string,
    modalType: PropTypes.number,
  }).isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape(searchFilterPropType)).isRequired,
  addFacet: PropTypes.func.isRequired,
  removeFacet: PropTypes.func.isRequired,
  facetClass: PropTypes.instanceOf(BaseFacet).isRequired,
};
export default FilterModalPatternB;
